// extracted by mini-css-extract-plugin
export var category = "Ratings-module--category--3c2de";
export var categoryCards = "Ratings-module--categoryCards--ae777";
export var categoryHeading = "Ratings-module--categoryHeading--1e104";
export var container = "Ratings-module--container--1ca0e";